const add = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

const get = (key) => {
  const data = localStorage.getItem(key);
  try {
    const o = JSON.parse(data);
    if (o && typeof o === 'object') {
      return o;
    }
    return data;
  } catch (e) {
    return data;
  }
};

const remove = key => localStorage.removeItem(key);

const clear = () => localStorage.clear();

export {
  add,
  get,
  remove,
  clear,
};



// WEBPACK FOOTER //
// ./src/utils/localStorage.js